<div class="posg-cont">
    <div class="posg-item" *ngFor='let item of posgrados;index as i' [ngClass]='"color-"+ i '><a [href]="item.systemTitle">{{item.title}}</a></div>            
  </div>